import ToastAlert from './ToastAlert';

const ProgressAlerts = () => {
  return <ToastAlert />;
};

export default ProgressAlerts;
